import { useNavigate, useLocation } from 'react-router-dom';

const Logo = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClick = () => {
    if (location.pathname === '/') {
      const page = document.getElementById('Home');
      if (page) {
        page.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
    }
  };

  return (
    <img
      alt='spacemap'
      src='/logo-white.svg'
      onClick={onClick}
      className='w-[172px] h-6 cursor-pointer pointer-events-auto'
    />
  );
};

export default Logo;
